<!-- <p>dashboard-rule-events works!</p> -->

<ng-template *ngIf="isMobileView then mobile else notMobile"></ng-template>

<ng-template #mobile>
    <div class="rule-events-box">
        <span style="font-size: large; font-weight: bolder;">Rule Events</span>
        <div>
            <div class="rule-events-info">
                <span>Rule</span>
                <span>Asset</span>
                <span>Timestamp</span>
            </div>
            <ejs-listbox [dataSource]='ruleEvents' [fields]="fields" class="listbox-container-mobile">
                <ng-template #itemTemplate let-data>
                    <div class="rule-events-info ejs-listbox-item" (click)="goToEvent(data)">
                        <span *ngIf="rules">{{ data.RuleName}}</span>
                        <span *ngIf="rules">{{ data.AssetName }}</span>
                        <span>{{ convertEpoch(data.TimeStamp) }}</span>
                    </div>
                </ng-template>
            </ejs-listbox>
        </div>
    </div>
</ng-template>

<ng-template #notMobile>
    <div>
        <div>
            <span style="font-size: large; font-weight: bolder;">Rule Events</span>
            <div>
                <div class="rule-events-info">
                    <span>Rule</span>
                    <span>Asset</span>
                    <span>Timestamp</span>
                    <!-- <span>Rule Active</span> Have another box for active alerts? -->
                </div>
                <ejs-listbox [dataSource]='ruleEvents' [fields]="fields" class="listbox-container">
                    <ng-template #itemTemplate let-data>
                        <div class="rule-events-info ejs-listbox-item" (click)="RuleEventSelected(data)">
                            <span *ngIf="rules">{{ data.RuleName}}</span>
                            <span *ngIf="rules">{{ data.AssetName }}</span>
                            <span>{{ convertEpoch(data.TimeStamp) }}</span>
                        </div>
                    </ng-template>
                </ejs-listbox>
            </div>
        </div>
        <br>
        <div *ngIf="SelectedEvent">
            <div style="display: flex;">
                <span style="font-size: large; font-weight: bolder;">Event Details</span>
                <button mat-raised-button (click)="deselectEvent()" style="margin: 0.25em; margin-bottom: 0.5em;">
                    <span>Collapse</span>
                    <mat-icon>expand_less</mat-icon>
                </button>
                <span class="toolbar-spacer"></span>
                <button mat-raised-button color="primary" (click)="goToEvent(SelectedEvent)"
                    style="margin: 0.25em; margin-bottom: 0.5em;" class="app-icon--goto">
                    <span>Go To Event</span>
                    <mat-icon/>
                </button>
                <button mat-raised-button color="primary" (click)="OpenRule(EventRule)"
                    style="margin: 0.25em; margin-bottom: 0.5em;">
                    <span>View Rule</span>
                    <mat-icon>visibility_on</mat-icon>
                </button>
            </div>
            <div class="event-details" *ngIf="EventRule && SelectedEvent">
                <span *ngIf="EventRule.RuleMessage">Rule Message:</span>
                <span *ngIf="EventRule.RuleMessage">{{ EventRule.RuleMessage }}</span>
                <span>Rule Name:</span>
                <span>{{ EventRule.RuleDescription }}</span>
                <span>Event Time:</span>
                <span>{{ convertEpoch(SelectedEvent.TimeStamp) }}</span>
                <span>Asset Name:</span>
                <span>{{ EventRule.AssetName }}</span>
            </div>
            <div class="value-conditions-grid">
                <span>Conditions:</span>
                <span>{{ splitValues(SelectedEvent.RuleText)[0] }}</span>
                <span> {{ splitValues(SelectedEvent.RuleText)[1] }}</span>
                <span>Values:</span>
                <span>{{ splitValues(SelectedEvent.RuleValues)[0] }}</span>
                <span> {{ splitValues(SelectedEvent.RuleValues)[1] }}</span>
                <span *ngIf="EventRule && EventRule.RuleDef && EventRule.RuleDef.length > 1">Operator:</span>
                <span
                    *ngIf="EventRule && EventRule.RuleDef && EventRule.RuleDef.length > 1">{{extractOperator(EventRule.RuleText)}}</span>
            </div>
        </div>
    </div>
</ng-template>